import React, { useEffect, useState, useContext, useRef } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';

import { InputNumber } from 'primereact/inputnumber';

import { useWeb3React } from "@web3-react/core";

import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { Message } from 'primereact/message';

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import { formatDecimals, formatCurrencyExtended, formatBalanceWithIcon, getTokenPrice, formatPercentage } from '../../utils';
import { miniCardHeaderStyle, miniInfoStyle, cardHeaderStyle, cardOutlineExtendedStyle, cardOutlineHeaderStyle, cardStyle, infoOutlineStyle } from "./TileStyles";

import { getGradientCardStyle } from "./TileStyles";
import rocketIcon from "../../imgs/rocket_icon.png";

import BigNumber from 'bignumber.js'

import { Progress } from '@nextui-org/react';

const DashboardModuleFuel = ({ data, getData }) => {

  const { library, account } = useWeb3React();
  const contractContext = useContext(ContractContext);
  const contracts = contractContext.contracts;
  const isWalletConnected = () => account !== null;

  const [isClaiming, setIsClaiming] = useState(false);

  const rocketFiPrice = getTokenPrice(data.tokensList, "ROCKETFI");

  const LoadingContent = () => <Skeleton width="100%" height="35px" className="mb-2" />;
  const LoadingTitle = () => <Skeleton width="70%" height="25px" className="mb-2" />;

  const toast = useRef(null);
  const message = useRef(null);

  const handleClaim = async () => {
    setIsClaiming(true);
    if (!isWalletConnected()) {
      console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }
    if (!contracts.rocketFuel) {
      console.error("RocketFuel contract not available.");
      return;
    }

    console.log("RocketFuel: Claim Rewards button clicked");

    try {
      const transaction = contracts.rocketFuel.methods.claimDividends().send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

    } catch (error) {
      console.error("Error interacting with the Rocket Fuel contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Rocket Fuel contract: ${error.message}`, life: 3000 });
    }

    getData();
    setIsClaiming(false);
  };

  const handleResync = async () => {
    if (!isWalletConnected()) {
      console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }
    if (!contracts.burnToEarnResync) {
      console.error("Burn To Earn Resync contract not available.");
      return;
    }

    console.log("Burn To Earn Resync: Resync button clicked");

    try {
      const transaction = contracts.burnToEarnResync.methods.resync().send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

      getData();
    } catch (error) {
      console.error("Error interacting with the Burn To Earn Resync contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Burn To Earn Resync contract: ${error.message}`, life: 3000 });
    }
  };

  const handleBurn = async (tokenAmount) => {
    if (!isWalletConnected()) {
      console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }
    if (!contracts.rocketFi) {
      console.error("RocketFi contract not available.");
      return;
    }

    console.log("RocketFi: Burn button clicked");

    try {
      console.log("Burning tokens:", tokenAmount);
      const transaction = contracts.rocketFi.methods.burnTokenOnly(tokenAmount).send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

    } catch (error) {
      console.error("Error interacting with the RocketFi contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the RocketFi contract: ${error.message}`, life: 3000 });
    }
    setTokensToBurn(null);
    getData();
  };

  const fuelCardStyle = getGradientCardStyle(rocketIcon, 'auto, auto 140%, auto', "rgba(150, 55, 0, 0.91)", "rgba(243, 125, 57, 0.9)");

  const [tokensToBurn, setTokensToBurn] = useState(0);
  return (
    <Card title={
      <div style={infoOutlineStyle}>Fuel Zone</div>}
      style={fuelCardStyle}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
        gap: '10px',
      }}>
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(115px, 1fr))', gap: '10px', marginTop: '10px' }}>
            <div>
              <div style={miniCardHeaderStyle}>
                {data?.contractData?.burnData?.rocketFuelAmount !== undefined
                  ? 'Your RocketFuel'
                  : <LoadingTitle />
                }
              </div>
              <div style={miniInfoStyle}>
                {data?.contractData?.burnData?.rocketFuelAmount !== undefined
                  ? formatDecimals(data.contractData.burnData.rocketFuelAmount, 9)
                  : <LoadingContent />}
              </div>
            </div>

            <div>
              <div style={miniCardHeaderStyle}>
                {data?.contractData?.burnData?.rocketFuelAmount !== undefined
                  ? 'RocketFuel Position'
                  : <LoadingTitle />
                }
              </div>
              <div style={miniInfoStyle}>
                {data?.contractData?.burnData?.rocketFuelAmount !== undefined
                  ? ((data.contractData.burnData.rocketFuelAmount / data.contractData.burnData.totalCirculatingRocketFuel) * 100).toFixed(2) + '%'
                  : <LoadingContent />}
              </div>
            </div>

            <div>
              <div style={miniCardHeaderStyle}>
                {data?.contractData?.burnData?.totalRealised !== undefined
                  ? 'RocketFi Earned'
                  : <LoadingTitle />
                }
              </div>
              <div style={miniInfoStyle}>
                {data?.contractData?.burnData?.totalRealised !== undefined
                  ? formatBalanceWithIcon(data.contractData.burnData.totalRealised, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", data?.dbData, 9)
                  : <LoadingContent />}
              </div>
              <div style={{ fontSize: "12px" }}>
                {data?.contractData?.burnData
                  ? formatCurrencyExtended((data.contractData.burnData.totalRealised / (10 ** 9)) * rocketFiPrice)
                  : <LoadingTitle />}
              </div>

            </div>

            <div>
              <div style={miniCardHeaderStyle}>
                {data?.contractData?.burnData?.totalCirculatingRocketFuel !== undefined
                  ? 'Total Circulating'
                  : <LoadingTitle />
                }
              </div>
              <div style={miniInfoStyle}>
                {data?.contractData?.burnData?.totalCirculatingRocketFuel !== undefined
                  ? formatDecimals(data.contractData.burnData.totalCirculatingRocketFuel, 9)
                  : <LoadingContent />}
              </div>
            </div>


            {/* <div>
              <div style={miniCardHeaderStyle}>
                {data?.contractData?.burnData?.totalRealisedUndeposited !== undefined &&
                  data?.contractData?.burnData?.unclaimedRocketFi !== undefined
                  ? 'Unclaimed RocketFi'
                  : <LoadingTitle />
                }
              </div>
              <div style={miniInfoStyle}>
                {data?.contractData?.burnData?.totalRealisedUndeposited !== undefined &&
                  data?.contractData?.burnData?.unclaimedRocketFi !== undefined
                  ? formatDecimals(parseFloat(data.contractData.burnData.totalRealisedUndeposited) + parseFloat(data.contractData.burnData.unclaimedRocketFi), 9)
                  : <LoadingContent />}
              </div>
              <div style={{ fontSize: "12px" }}>
                {data?.contractData?.burnData
                  ? formatCurrencyExtended(((parseFloat(data.contractData.burnData.totalRealisedUndeposited) + parseFloat(data.contractData.burnData.unclaimedRocketFi)) / (10 ** 9)) * rocketFiPrice)
                  : <LoadingTitle />}
              </div>
            </div> */}
          </div>
          {/* {data?.contractData?.burnData && data.contractData.burnData.totalRealisedUndeposited + data.contractData.burnData.unclaimedRocketFi > 0 &&
          (
            isClaiming ? <div style={{  width: '100%', justifyContent: 'center', marginTop: '10px' }}><Progress
            indeterminated
            color="gradient"
            status="secondary"
            size="xl"

          /></div> : <>
          <Button
            rounded
            severity="warning"
            onClick={handleClaim}
            size="small"
            style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}
          >
            Claim Rewards
          </Button>
          </>)
          } */}

        </div>

        <div style={{ marginTop: '10px' }} >
          <Card title={
            data?.contractData?.forgeData?.referralCode !== undefined
              ? <div style={cardOutlineHeaderStyle}>Fuel Generator</div>
              : <Skeleton width="70%" height="25px" className="mb-2" />
          }
            style={cardStyle}>
            <br />
            Burn RocketFi and generate RocketFuel <br /><br />
            RocketFuel rewards you RocketFi perpetually from all burn plays and RocketFi swaps. <br /><br />

            {tokensToBurn > 0 && <div style={{ marginTop: '5px', marginBottom: '5px' }}>
              <Message severity="warn" text={"Burning tokens results in a permanent loss of the token amount selected. Burn responsibly."} />
            </div>}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '10px' }}>



            </div>
            <InputNumber value={tokensToBurn ? tokensToBurn : null} onValueChange={(e) => setTokensToBurn(e.value)} minFractionDigits={0} maxFractionDigits={9}
              min={0}
              showButtons step={1000000}
              inputId="stacked-buttons"
              size="small"
              style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}
              decrementButtonClassName="p-button-danger"
              incrementButtonClassName="p-button-danger"
            />
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              rounded
              severity="danger"
              onClick={() => { handleBurn(new BigNumber(tokensToBurn).times(10 ** 9).toFixed(0).toString()) }}
              size="small"
              style={{
                justifyContent: 'center',
                marginTop: '10px',
                alignSelf: 'center', // Adjusts the vertical alignment
                width: '200px',
                justifyContent: 'center',
                marginLeft: '10px',
                marginRight: '10px',
            }}
              disabled={tokensToBurn === null || tokensToBurn === 0 || new BigNumber(tokensToBurn).times(10 ** 9).gt(new BigNumber(data?.contractData?.tokenData?.rocketFiBalance))}
            >
              Burn RocketFi
            </Button>
            </div>


          </Card>

        </div>

        {data?.contractData?.burnData && (data.contractData.burnData.totalSold > 0) && <Button
          rounded
          severity="warning"
          onClick={handleResync}
          size="small"
          style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}
        >
          Issue Detected - Click to Resync
        </Button>}
      </div>
      <Toast ref={toast} />
    </Card>
  );
}

export default React.memo(DashboardModuleFuel);
